var map = {
	"./l1.jpg": 634,
	"./l2.jpg": 635,
	"./l3.jpg": 636,
	"./l4.jpg": 637,
	"./l5.jpg": 638,
	"./l6.jpg": 639,
	"./l7.jpg": 640,
	"./l8.jpg": 641
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 968;


//////////////////
// WEBPACK FOOTER
// ./static/images/landing_page nonrecursive \.(jpg)$
// module id = 968
// module chunks = 0